module.exports = __webpack_public_path__ + "img/lifestyle_new.0d82aa85.png";